import { LOCAL_STORAGE_VALUES } from 'common/constants'
import LocalStorageService from 'common/utils/LocalStorageService'

export const isProfileWorkPromptHidden = (): boolean => {
  return !!LocalStorageService.getItem(LOCAL_STORAGE_VALUES.IS_PROFILE_WORK_PROMPT_HIDDEN) === true
}

export const setProfileWorkPrompt = (isHidden: boolean): void => {
  LocalStorageService.setItem(LOCAL_STORAGE_VALUES.IS_PROFILE_WORK_PROMPT_HIDDEN, isHidden, true)
}

export const resetProfileWorkPrompt = (): void => {
  LocalStorageService.removeItem(LOCAL_STORAGE_VALUES.IS_PROFILE_WORK_PROMPT_HIDDEN)
}
